export var GenerateTrailerStatus;
(function (GenerateTrailerStatus) {
    GenerateTrailerStatus["Pending"] = "pending";
    GenerateTrailerStatus["InQueue"] = "in-queue";
    GenerateTrailerStatus["InProgress"] = "in-progress";
    GenerateTrailerStatus["PreviewReady"] = "preview-ready";
    GenerateTrailerStatus["Ready"] = "ready";
    GenerateTrailerStatus["Failed"] = "failed";
})(GenerateTrailerStatus || (GenerateTrailerStatus = {}));
export var ReversedSortOrders;
(function (ReversedSortOrders) {
    ReversedSortOrders["ReverseCustom"] = "-custom";
    ReversedSortOrders["ReverseRelevance"] = "-relevance";
    ReversedSortOrders["ReverseDate"] = "-date";
    ReversedSortOrders["ReverseName"] = "-name";
})(ReversedSortOrders || (ReversedSortOrders = {}));
//# sourceMappingURL=video.types.js.map